<div class="min-vh-100 bg-light">
  <app-header [page]="'Additional Documents'"></app-header>

  <main class="container py-4">
    <button class="btn btn-link px-0 text-decoration-none mb-3" type="button" [routerLink]="['/account/additional-documents']">← Back to requests</button>

    <div *ngIf="loading" class="card border-0 shadow-sm">
      <div class="card-body text-center py-5"><div class="spinner-border spinner-border-sm me-2"></div>Loading request...</div>
    </div>

    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

    <ng-container *ngIf="!loading && request">
      <div class="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4">
        <div>
          <div class="d-flex flex-wrap align-items-center gap-2 mb-1">
            <h4 class="fw-bold mb-0">{{ request.title }}</h4>
            <span class="badge" [ngClass]="statusClass(request.status)">{{ request.status }}</span>
          </div>
          <div class="text-muted">Request received {{ request.requestedAt | date:'medium' }}</div>
        </div>
        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="load()">Refresh</button>
      </div>

      <div *ngIf="request.status === 'Approved'" class="alert alert-success shadow-sm">
        <strong>Approved.</strong> Your document passed review. If payment verification was already received, the held deposit has been completed.
      </div>
      <div *ngIf="request.status === 'Submitted' || request.status === 'UnderReview'" class="alert alert-warning shadow-sm">
        <strong>Review in progress.</strong> Your deposit remains paused and will not be credited until this document is approved.
      </div>
      <div *ngIf="request.status === 'AwaitingReplacement'" class="alert alert-danger shadow-sm">
        <strong>A replacement document is required.</strong> {{ request.lastRejectionReason || 'Please review the request and upload another document.' }}
      </div>

      <div class="row g-4">
        <div class="col-lg-8">
          <div class="card border-0 shadow-sm mb-4">
            <div class="card-body">
              <h5 class="fw-bold">What you need to provide</h5>
              <p class="mb-3 preserve-lines">{{ request.instructions }}</p>
              <div *ngIf="request.reason" class="rounded bg-light p-3 small">
                <div class="text-muted mb-1">Reason for request</div>
                <div>{{ request.reason }}</div>
              </div>
            </div>
          </div>

          <div class="card border-0 shadow-sm mb-4" *ngIf="canUpload">
            <div class="card-body">
              <h5 class="fw-bold">{{ request.status === 'AwaitingReplacement' ? 'Upload replacement document' : 'Upload document' }}</h5>
              <p class="text-muted small">Select the requested document. PDF, JPG, PNG and other common document formats are supported.</p>

              <input class="form-control mb-3" type="file" (change)="onFileSelected($event)" [disabled]="uploading">

              <div *ngIf="selectedFile" class="border rounded p-3 mb-3 small">
                <div class="fw-semibold text-break">{{ selectedFile.name }}</div>
                <div class="text-muted">{{ fileSize(selectedFile.size) }} · {{ selectedFile.type || 'Unknown file type' }}</div>
              </div>

              <button class="btn btn-primary" type="button" (click)="upload()" [disabled]="!selectedFile || uploading">
                <span *ngIf="uploading" class="spinner-border spinner-border-sm me-2"></span>
                {{ uploading ? uploadStage : 'Upload and submit for review' }}
              </button>
            </div>
          </div>

          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <h5 class="fw-bold mb-3">Submission history</h5>
              <div *ngIf="!request.submissions.length" class="text-muted small">No document has been submitted yet.</div>

              <div class="border rounded p-3 mb-3" *ngFor="let submission of request.submissions">
                <div class="d-flex flex-wrap justify-content-between gap-3">
                  <div>
                    <div class="fw-semibold">Attempt {{ submission.attemptNumber }} · {{ submission.fileName }}</div>
                    <div class="small text-muted">{{ fileSize(submission.fileSizeBytes) }} · {{ submission.createdAt | date:'medium' }}</div>
                  </div>
                  <div class="d-flex align-items-start gap-2">
                    <span class="badge" [ngClass]="statusClass(submission.status)">{{ submission.status }}</span>
                    <button *ngIf="submission.status !== 'AwaitingUpload'" class="btn btn-outline-secondary btn-sm" type="button"
                      (click)="download(submission)" [disabled]="downloadingId === submission.id">
                      {{ downloadingId === submission.id ? 'Opening...' : 'View' }}
                    </button>
                  </div>
                </div>
                <div *ngIf="submission.rejectionReason" class="alert alert-danger py-2 px-3 mt-3 mb-0 small">
                  <strong>Rejected:</strong> {{ submission.rejectionReason }}
                </div>
                <div *ngIf="submission.reviewNotes" class="small mt-3"><span class="text-muted">Review notes:</span> {{ submission.reviewNotes }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="card border-0 shadow-sm sticky-lg-top details-card">
            <div class="card-body">
              <h6 class="fw-bold">Deposit details</h6>
              <dl class="row small mb-0">
                <dt class="col-5 text-muted">Amount</dt>
                <dd class="col-7 text-end">{{ request.depositAmount | number:'1.2-2' }} {{ request.depositCurrency || '' }}</dd>
                <dt class="col-5 text-muted">Deposit status</dt>
                <dd class="col-7 text-end">{{ request.depositStatus || '—' }}</dd>
                <dt class="col-5 text-muted">Review status</dt>
                <dd class="col-7 text-end">{{ request.depositDocumentReviewStatus || '—' }}</dd>
                <dt class="col-5 text-muted">Deposit ID</dt>
                <dd class="col-7 text-end font-monospace text-break">{{ request.depositId || '—' }}</dd>
                <dt class="col-5 text-muted">Attempt</dt>
                <dd class="col-7 text-end">{{ request.currentAttemptNumber || 0 }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <app-footer></app-footer>
  </main>
</div>
